import { Size2D } from "../interfaces/shared";
import { EditorResizeDraftOperation, EditorResizeMode } from '../editor-domain.models';

export class ResizeViewModel {
  constructor(private readonly initialSize: Size2D) {
    this.width$ = initialSize.width;
    this.height$ = initialSize.height;
    this.scaleX$ = 1;
    this.scaleY$ = 1;
    this.keepAspectRatio$ = true;
    this.mode$ = 'percentage';
    this.aspectRatio$ = this.width$ / this.height$;
  }

  private readonly aspectRatio$: number;
  private width$: number;
  private height$: number;
  private scaleX$: number;
  private scaleY$: number;
  private keepAspectRatio$: boolean;
  private mode$: EditorResizeMode;

  set width(value: number) {
    this.mode$ = 'dimensions';
    this.width$ = value;
    this.scaleX$ = value / this.initialSize.width;

    if (this.keepAspectRatio$) {
      this.height$ = this.width$ / this.aspectRatio$;
      this.scaleY$ = this.scaleX$;
    }
  }
  get width(): number {
    return Math.round(this.width$);
  }

  set height(value: number) {
    this.mode$ = 'dimensions';
    this.height$ = value;
    this.scaleY$ = value / this.initialSize.height;

    if (this.keepAspectRatio$) {
      this.width$ = value * this.aspectRatio$;
      this.scaleX$ = this.scaleY$;
    }
  }
  get height(): number {
    return Math.round(this.height$);
  }

  set scaleXPercentage(value: number) {
    this.mode$ = 'percentage';
    this.scaleX$ = value / 100;
    this.width$ = this.initialSize.width * this.scaleX$;

    if (this.keepAspectRatio$) {
      this.scaleY$ = this.scaleX$;
      this.height$ = this.width$ / this.aspectRatio$;
    }
  }
  get scaleXPercentage(): number {
    return Math.round(this.scaleX$ * 100);
  }

  set scaleYPercentage(value: number) {
    this.mode$ = 'percentage';
    this.scaleY$ = value / 100;
    this.height$ = this.initialSize.height * this.scaleY$;

    if (this.keepAspectRatio$) {
      this.scaleX$ = this.scaleY$;
      this.width$ = this.height$ * this.aspectRatio$;
    }
  }
  get scaleYPercentage(): number {
    return Math.round(this.scaleY$ * 100);
  }
  
  set keepAspectRatio(value: boolean) {
    this.keepAspectRatio$ = value;

    if (this.keepAspectRatio$) {
      this.scaleY$ = this.scaleX$;
      this.height$ = this.width$ / this.aspectRatio$;
    }
  }
  get keepAspectRatio(): boolean {
    return this.keepAspectRatio$;
  }

  getResizeParams(): EditorResizeDraftOperation['params'] {
    return {
      scaleX: this.scaleX$,
      scaleY: this.scaleY$,
      mode: this.mode$,
      keepAspectRatio: this.keepAspectRatio$,
    };
  }
}
